import { CHART_TYPES } from "@/components/Survey/ResultsV2/constants";
import { isMatrixLikeCard, isMatrixMultipleLikeCard } from "@utils/hiddenCardQuestionType";

export const BAR_CHART_TYPES = [CHART_TYPES.BAR_CLUSTERED, CHART_TYPES.COLUMN_CLUSTERED];

export const SUBTOTALS_CHART_HINT = "Not available with subtotals";

const SUBTOTALS_ELIGIBLE_TYPES = [
  "q_single", "q_rating", "q_slider", "q_nps", "q_image_choice", "q_image_choice_multiple", "q_matrix",
];

export function supportsSubtotals(meta) {
  if (!meta) return false;
  if (meta.type === "q_matrix" && meta.specs?.matrix_type === "multiple") return false;
  return SUBTOTALS_ELIGIBLE_TYPES.includes(meta.type);
}

export function defaultChartTypeFor(meta) {
  const type = meta?.type;
  if (type === "q_nps" || meta?.specs?.matrix_type === "nps") return CHART_TYPES.NPS;
  if (type === "q_ranking") return CHART_TYPES.RANKING_FLOW;
  if (isMatrixMultipleLikeCard(meta)) return CHART_TYPES.BAR_CLUSTERED;
  if (isMatrixLikeCard(meta) || type === "q_rating") return CHART_TYPES.BAR_STACKED_100;
  return CHART_TYPES.BAR_CLUSTERED;
}

export function toBarChartType(chartType) {
  if (BAR_CHART_TYPES.includes(chartType)) return chartType;
  return chartType === CHART_TYPES.COLUMN_STACKED_100 ? CHART_TYPES.COLUMN_CLUSTERED : CHART_TYPES.BAR_CLUSTERED;
}

export function rankLabel(rank) {
  const mod100 = rank % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${rank}th`;
  return `${rank}${["th", "st", "nd", "rd"][rank % 10] || "th"}`;
}

// Positions 1..N of a ranking card, N = its max or its answer count.
export function rankingPositions(meta) {
  const s = meta?.specs || {};
  const count = Number(s.max) || (s.answers || []).length;
  return Array.from({ length: count }, (_, i) => ({ code: String(i + 1), label: rankLabel(i + 1) }));
}
